import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'archived-icon',
  templateUrl: './archived-icon.component.html',
  styleUrls: ['./archived-icon.component.scss']
})
export class ArchivedIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
